import reducerRegistry from './../../helpers/ReducerRegistry';
import priceDepthService from '../../../core/services/Prices/PriceDepth/PriceDepthService';
import {
  getDataFollowKeyByDot,
  getSyncDefaultSearch,
} from '../../helpers/Common';
import Const from './Const';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';

const REDUCER_NAME = 'PRICE_DEPTH_:';
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const FETCH_DATA_PRICE_DEPTH = `${REDUCER_NAME}FETCH_DATA_PRICE_DEPTH`;
const SET_CONDITION = `${REDUCER_NAME}SET_CONDITION`;
const SUBSCRIBE_REALTIME_DATA_BIDASK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_BIDASK`;
const SUBSCRIBE_REALTIME_DATA_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_TICK`;
const SUBSCRIBE_REALTIME_DATA_DERIVATIVE = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_DERIVATIVE`;
const RESET_REALTIME_DATA = `${REDUCER_NAME}RESET_REALTIME_DATA`;

export {
  REDUCER_NAME,
  reducer as default,
  fetchDataPriceDepth,
  setCondition,
  subscribeRealtimeBidAsk,
  subscribeRealtimeTick,
  subscribeRealtimeDerivative,
};

function subscribeRealtimeTick(data, code, id) {
  const result = data.find(bidAsk => bidAsk.organCode === code);
  return {
    type: SUBSCRIBE_REALTIME_DATA_TICK,
    payload: {
      result,
      id,
    },
  };
}

function subscribeRealtimeDerivative(data, code, id) {
  const result = data.find(item => item.derivativeCode === code);
  return {
    type: SUBSCRIBE_REALTIME_DATA_DERIVATIVE,
    payload: {
      result,
      id,
    },
  };
}

function subscribeRealtimeBidAsk(data, code, id) {
  const result = data.find(bidAsk => bidAsk.organCode === code);
  return {
    type: SUBSCRIBE_REALTIME_DATA_BIDASK,
    payload: {
      result,
      id,
    },
  };
}

function setCondition(value, id) {
  return dispatch => {
    dispatch({
      type: SET_CONDITION,
      payload: {
        currentSearch: value,
        conditionId: id,
      },
    });

    dispatch({
      type: RESET_REALTIME_DATA,
      payload: {
        value: value.code,
        id,
      },
    });
  };
}

function fetchDataPriceDepth(params, id) {
  const formatParams = formattedParams(params);
  return dispatch => {
    priceDepthService.getPriceDepth(formatParams).then(response => {
      const { items } = response;
      dispatch({
        type: FETCH_DATA_PRICE_DEPTH,
        payload: {
          priceDepthData: items && items.length ? items[0] : {},
          componentId: id,
        },
      });
    });
  };
}

function formattedParams(params) {
  let { code } = params;
  return {
    Code: code || 'AAA',
  };
}

const initialState = {
  listMultiComponent: {},
  listMultiCondition: {},
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const { dragCode, id: dataId } = action.payload;

      const condition = currentState.get(
        ConstCommon.listComponent.PriceDepth,
        'condition',
        dataId,
      );

      return {
        ...state,
        ...initialState,
        listMultiCondition: {
          ...(state.listMultiCondition || {}),
          [dataId]: {
            condition: dragCode
              ? {
                  code: dragCode.organCode,
                  displayCode: dragCode.ticker,
                  isDerivatives: false,
                }
              : condition ||
                getSyncDefaultSearch(ConstCommon.listComponent.PriceDepth) || {
                  code: Const.defaultCode,
                  displayCode: Const.defaultCode,
                  isDerivatives: false,
                },
          },
        },
        listMultiComponent: {
          ...(state.listMultiComponent || {}),
          [dataId]: {
            priceDepthData: {},
            realTimeData: {},
          },
        },
      };

    case UNMOUNT_COMPONENT:
      const delId = action.payload.id;
      const cloneListComponent = { ...state.listMultiComponent };
      const { [delId]: _, ...withoutDeleteKey } = cloneListComponent;
      if (Object.keys(withoutDeleteKey).length === 0) {
        return {};
      }
      return {
        ...state,
        listMultiComponent: withoutDeleteKey,
      };

    case FETCH_DATA_PRICE_DEPTH:
      const { priceDepthData, componentId } = action.payload;
      if (!state.listMultiComponent || !state.listMultiComponent[componentId]) {
        return state;
      }
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            priceDepthData: { ...priceDepthData },
          },
        },
      };

    case SET_CONDITION: {
      const { currentSearch, conditionId } = action.payload;

      const { isDerivatives, code, displayCode } = currentSearch;

      if (!('isDerivatives' in currentSearch)) {
        currentSearch.isDerivatives = false;
      }

      currentState.add(
        ConstCommon.listComponent.PriceDepth,
        'condition',
        { isDerivatives, code, displayCode },
        conditionId,
      );

      const clone = {
        ...state.listMultiCondition,
        [conditionId]: {
          ...state.listMultiCondition[conditionId],
          condition: {
            ...state.listMultiCondition[conditionId].condition,
            ...currentSearch,
          },
        },
      };

      return {
        ...state,
        listMultiCondition: clone,
      };
    }

    case SUBSCRIBE_REALTIME_DATA_BIDASK:
      const { result, id } = action.payload;
      if (result) {
        const LIST_10_DATA = Const.realTimeData.LIST_10_DATA.map((_, index) => {
          return {
            comGroupCode: result.comGroupCode,
            BID: getDataFollowKeyByDot(
              result,
              Const.realTimeData.LIST_10_DATA[index].BID,
            ),
            BID_VOLUME: getDataFollowKeyByDot(
              result,
              Const.realTimeData.LIST_10_DATA[index].BID_VOLUME,
            ),
            ASK: getDataFollowKeyByDot(
              result,
              Const.realTimeData.LIST_10_DATA[index].ASK,
            ),
            ASK_VOLUME: getDataFollowKeyByDot(
              result,
              Const.realTimeData.LIST_10_DATA[index].ASK_VOLUME,
            ),
            TRADING_DATE: getDataFollowKeyByDot(
              result,
              Const.realTimeData.LIST_10_DATA[index].TRADING_DATE,
            ),
          };
        });

        return {
          ...state,
          listMultiComponent: {
            ...state.listMultiComponent,
            [id]: {
              ...state.listMultiComponent[id],
              realTimeData: {
                ...state.listMultiComponent[id].realTimeData,
                LIST_10_DATA,
                symbolInformation: {
                  ...state.listMultiComponent[id].realTimeData
                    .symbolInformation,
                  BID: getDataFollowKeyByDot(result, Const.realTimeData.BID),
                  ASK: getDataFollowKeyByDot(result, Const.realTimeData.ASK),
                },
              },
            },
          },
        };
      }

      return state;

    case SUBSCRIBE_REALTIME_DATA_TICK:
    case SUBSCRIBE_REALTIME_DATA_DERIVATIVE:
      const rs = action.payload.result;
      const cId = action.payload.id;
      if (rs) {
        const indexInfo = {
          MatchPrice: getDataFollowKeyByDot(rs, Const.realTimeData.MATCH_PRICE),
          marketStatus: getDataFollowKeyByDot(rs, 'marketStatus'),
          PriceChange: getDataFollowKeyByDot(
            rs,
            Const.realTimeData.PRICE_CHANGE,
          ),
          PercentPriceChange: getDataFollowKeyByDot(
            rs,
            Const.realTimeData.PERCENT_PRICE_CHANGE,
          ),
          OPEN_PRICE: getDataFollowKeyByDot(rs, Const.realTimeData.OPEN_PRICE),
          HIGHEST_PRICE: getDataFollowKeyByDot(
            rs,
            Const.realTimeData.HIGHEST_PRICE,
          ),
          LOWEST_PRICE: getDataFollowKeyByDot(
            rs,
            Const.realTimeData.LOWEST_PRICE,
          ),
          ReferencePrice: getDataFollowKeyByDot(
            rs,
            Const.realTimeData.REFERENCE_PRICE,
          ),
          CeilingPrice: getDataFollowKeyByDot(
            rs,
            Const.realTimeData.CEILING_PRICE,
          ),
          FloorPrice: getDataFollowKeyByDot(rs, Const.realTimeData.FLOOR_PRICE),
          TradingDate: getDataFollowKeyByDot(
            rs,
            Const.realTimeData.TRADING_DATE,
          ),
          TotalMatchVolume: getDataFollowKeyByDot(
            rs,
            Const.realTimeData.TOTAL_MATCH_VOLUME,
          ),
        };

        return {
          ...state,
          listMultiComponent: {
            ...state.listMultiComponent,
            [cId]: {
              ...state.listMultiComponent[cId],
              realTimeData: {
                ...state.listMultiComponent[cId].realTimeData,
                symbolInformation: {
                  ...state.listMultiComponent[cId].realTimeData
                    .symbolInformation,
                  ...indexInfo,
                },
              },
            },
          },
        };
      }

      return state;

    case RESET_REALTIME_DATA:
      const resetId = action.payload.id;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [resetId]: {
            ...state.listMultiComponent[resetId],
            realTimeData: {},
          },
        },
      };

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
